import {
  Box,
  IconButton,
  Typography,
} from '@mui/material';
import {styled} from '@mui/system';

export const LoadingContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.down('sm')]: {
    height: '100vh',
    width: '100%',
  },
  [theme.breakpoints.up('sm')]: {
    height: '400px',
    width: '600px',
  },
}));

export const EventContainer = styled(Box)(({theme}) => ({
  flexDirection: 'column',
  backgroundColor: theme.palette.background.default,
  flexGrow: '1',
  padding: 0,
  // width: '100%',
  height: '100%',
  overflow: 'hidden',
  position: 'static',
}));

export const SidebarContainer = styled(Box)(({theme}) => ({
  width: '25rem',
  minWidth: '350px',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: '0',
  padding: '24px 39px',
  position: 'relative',
  height: '100%',
  overflowY: 'auto',
  [theme.breakpoints.up('sm')]: {
    borderRight: `1px solid ${theme.palette.common.swatch['30']}`,
    flexShrink: 0,
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    padding: '12px 20px 0px',
    position: 'sticky',
    top: 0,
    zIndex: 99,
    backgroundColor: theme.palette.background.default,
  },
}));

export const MainContainer = styled(Box)(({theme}) => ({
  flexGrow: '1',
  padding: '24px 40px 8px',
  backgroundColor: theme.palette.background.default,
  height: '100%',
  overflowY: 'auto',
  [theme.breakpoints.up('sm')]: {
    minWidth: '360px',
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    padding: '0px 20px 8px',
  },
}));

export const EventStack = styled(Box)(({theme}) => ({
  flexDirection: 'row',
  flexWrap: 'nowrap',
  height: '100%',
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    overflow: 'auto',
  },
}));

export const DateSection = styled(Box)(({theme}) => ({
  padding: 0,
  flexGrow: 1,
}));

export const TypographyH3 = styled(Typography)(({theme}) => ({
  color: theme.palette.common.black,
  fontWeight: '500',
  fontSize: '1.25rem',
  lineHeight: '1.5rem',
}));

export const TypographyH5 = styled(Typography)(({theme}) => ({
  color: theme.palette.text.primary,
  fontWeight: '700',
  fontSize: '1rem',
  lineHeight: '1.5rem',
  marginTop: '10px',
}));

export const TypographyBody2 = styled(Typography)(({theme}) => ({
  color: theme.palette.text.secondary,
  fontWeight: '400',
  fontSize: '.875rem',
  lineHeight: '1.25rem',
}));

export const TypographyBody3 = styled(Typography)(({theme}) => ({
  color: theme.palette.common.black,
  fontWeight: '400',
  fontSize: '.75rem',
  lineHeight: '1rem',
}));

export const PrimaryButtonText = styled(Typography)(({theme}) => ({
  fontWeight: '500',
  fontSize: '.875rem',
  lineHeight: '1.25rem',
}));

export const NavButton = styled(IconButton)(({theme}) => ({
  position: 'absolute',
  left: '18px',
  top: '12px',
  zIndex: 9999, // Must be larger than ZmWebHeader's z-index
  fontWeight: 'bolder',
  height: '1rem',
  width: '1rem',
  color: theme.palette.text.primary,
}));
